import { createFileRoute } from '@tanstack/react-router'
import { StatementSection, statementLoader } from '@ufc/domains/finance'

export const Route = createFileRoute('/finance/statement')({
  loader: statementLoader,
  component: StatementPage,
})

function StatementPage() {
  return <StatementSection />
}
